var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FileText",
    clipPath: "url(#clip0_1061_2615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3125 22.75H5.6875C5.47201 22.75 5.26535 22.6644 5.11298 22.512C4.9606 22.3597 4.875 22.153 4.875 21.9375V4.0625C4.875 3.84701 4.9606 3.64035 5.11298 3.48798C5.26535 3.3356 5.47201 3.25 5.6875 3.25H15.4375L21.125 8.9375V21.9375C21.125 22.153 21.0394 22.3597 20.887 22.512C20.7347 22.6644 20.528 22.75 20.3125 22.75Z",
    stroke: "#7F8496",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4375 3.25V8.9375H21.125",
    stroke: "#7F8496",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.75 13.8125H16.25",
    stroke: "#7F8496",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.75 17.0625H16.25",
    stroke: "#7F8496",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1061_2615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText);
export default __webpack_public_path__ + "static/media/FileText.289d19e4c178da89cdc1200764db48a0.svg";
export { ForwardRef as ReactComponent };